module.exports = __webpack_public_path__ + "static/media/mobmodal.a9a3ce99.jpg";